// @ts-check

import angular from 'angular';

/**
 * Get Module
 */
angular
  .module('RcmDialog')

  /**
   * RcmDialog.rcmFormDialog
   */
  .directive('rcmFormDialog', [
    '$compile',
    '$http',
    function ($compile, $http) {
      return {
        restrict: 'A',
        compile(tElement, tAttrs, transclude) {
          return function (/** @type {any} */ scope, elm, attrs, ctrl) {
            const dialogId = attrs.rcmFormDialog;

            scope.dialog = RcmDialog.getDialog(dialogId);

            // Bring in contentscope scope vars
            scope.contentscope = scope.dialog.contentscope;

            const existingAction = scope.dialog.getAction('save');

            let formAction = new RcmDialog.action();

            formAction.type = 'button';
            formAction.label = 'Save';
            formAction.css = 'btn btn-primary';
            formAction.method = function (dialog) {
              scope.dialog.loading = true;
              // @todo may need scope.$apply()
              const content = elm.find('.modal-body');
              const form = elm.find('form');
              const actionUrl = form.attr('action');

              jQuery
                .post(actionUrl, form.serialize())
                .done(function (data) {
                  scope.dialog.loading = false;
                  scope.$apply();
                })
                .fail(function () {
                  scope.dialog.loading = false;
                  scope.$apply();
                })
                .always(function (data) {
                  content.html(data);
                  scope.dialog.loading = false;
                  $compile(content)(scope);
                  scope.$apply();
                });
            };

            if (existingAction) {
              formAction = angular.extend(formAction, existingAction);
            }

            scope.dialog.setAction('save', formAction);

            $http({ method: 'GET', url: scope.dialog.url })
              .success(function (data, status, headers, config) {
                const contentBody = elm.find('.modal-body');
                contentBody.html(data);
                scope.dialog.loading = false;
                $compile(contentBody)(scope);
                // @todo may need scope.$apply()
              })
              .error(function (data, status, headers, config) {
                scope.dialog.loading = false;
                // @todo may need scope.$apply()
              });

            scope.$apply();
          };
        },
        scope: {},
        template:
          '' +
          '<div id="RcmFormDialogIn" style="display: block;" ng-hide="dialog.loading">' +
          ' <div class="modal-dialog">' +
          '  <div class="modal-content">' +
          '   <div class="modal-header">' +
          '    <button ng-show="dialog.actions.close.type == \'button\'" type="button" class="close" aria-hidden="true" data-ng-click="dialog.actions.close.method(dialog)">&times;</button>' +
          '    <h1 class="modal-title" id="myModalLabel">{{dialog.title}}</h1>' +
          '   </div>' +
          '   <div class="modal-body"><!-- CONTENT LOADED HERE --></div>' +
          '   <div class="modal-footer">' +
          '    <button ng-repeat="(key, action) in dialog.actions" ng-show="action.type == \'button\'" type="button" class="{{action.css}}" data-ng-click="action.method(dialog)" >' +
          '        {{action.label}}' +
          '    </button>' +
          '   </div>' +
          '  </div>' +
          ' </div>' +
          '</div>',
      };
    },
  ]);
